import React from 'react';
import { Link } from 'react-router-dom';

export function GabryxLogo({ size = 20, className = '', variant = 'color' }) {
  const orangeColor = variant === 'white' ? '#FFFFFF' : '#FF6B00';
  const textColor = variant === 'white' ? '#FFFFFF' : '#111827';

  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid="gabryx-logo">
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="18" stroke={orangeColor} strokeWidth="4.5" fill="none" />
        <path d="M22 14H30C30 14 32 14 32 16V18H24V22H30V26C30 28 28 30 26 30H20C16 30 14 28 14 24V16C14 12 18 10 22 10" stroke={orangeColor} strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
      <span style={{ color: textColor, fontWeight: 900, fontSize: size * 0.85, letterSpacing: '0.06em', fontFamily: "'Inter', 'Poppins', sans-serif" }}>
        GABRYX
      </span>
    </span>
  );
}

export function LegalFooterLinks({ variant = 'dark' }) {
  const linkClass = variant === 'light'
    ? 'text-gray-500 hover:text-gray-800'
    : 'text-white/40 hover:text-white/70';
  const separatorClass = variant === 'light' ? 'text-gray-300' : 'text-white/20';

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 text-[10px]" data-testid="legal-footer-links">
      <Link to="/cgv" className={`${linkClass} transition-colors`}>CGV</Link>
      <span className={separatorClass}>|</span>
      <Link to="/mentions-legales" className={`${linkClass} transition-colors`}>Mentions légales</Link>
      <span className={separatorClass}>|</span>
      <Link to="/confidentialité" className={`${linkClass} transition-colors`}>Confidentialité</Link>
      <span className={separatorClass}>|</span>
      <Link to="/cgu" className={`${linkClass} transition-colors`}>CGU</Link>
    </div>
  );
}

export function GabryxFooter({ variant = 'sidebar' }) {
  if (variant === 'sidebar') {
    return (
      <div className="mt-3 pt-3 border-t border-[#E5E7EB] flex flex-col items-center gap-1.5" data-testid="gabryx-footer">
        <p className="text-[10px] text-[#6B7280]">
          Solution développée par
        </p>
        <GabryxLogo size={16} />
        <Link to="/presentation" target="_blank" rel="noreferrer"
          className="text-[10px] text-[#FF6B00] hover:text-[#c85400] font-medium mt-1 flex items-center gap-1"
          data-testid="footer-discover-link">
          Nous découvrir →
        </Link>
        <LegalFooterLinks variant="light" />
      </div>
    );
  }

  if (variant === 'login') {
    return (
      <div className="mt-6 space-y-3" data-testid="login-gabryx">
        <div className="py-3.5 flex items-center justify-center gap-2 bg-[#1F2937] rounded-lg">
          <span className="text-[11px] text-white/50 font-medium">by</span>
          <GabryxLogo size={16} variant="white" />
        </div>
        <LegalFooterLinks variant="light" />
        <p className="text-center text-[10px] text-gray-400">&copy; {new Date().getFullYear()} GABRYX — CHANTIX</p>
      </div>
    );
  }

  if (variant === 'presentation') {
    return (
      <div className="flex flex-col items-center gap-4 py-6" data-testid="presentation-gabryx">
        <div className="w-20 h-0.5 bg-[#FF6B00]/40 rounded-full" />
        <p className="text-[15px] text-[#4B5563] text-center max-w-lg leading-relaxed">
          <span className="font-black text-[#111827]">CHANTIX</span> est une solution développée par{' '}
          <span className="font-black text-[#FF6B00]">GABRYX</span>, dediee a la gestion digitale des chantiers OPC et CSPS.
        </p>
        <GabryxLogo size={22} />
      </div>
    );
  }

  return null;
}
